<section id="preview" class="section">
    <div class="container section-title" data-aos="fade-up">
        @if(pdfUrl){
            <h2>Invoice <span>Ready</span></h2>
            <p>Your PDF invoice is ready!</p>
        } @else {
            <h2>No <span>Invoice</span></h2>
            <p>Please generate an invoice first</p>
        }
    </div>
    <div class="container">
        <div class="row">
            <div class="d-flex flex-column justify-content-center align-items-center mb-3">
                 
                <div class="container text-center">
                    <div class="d-flex flex-column justify-content-center align-items-center">
                        @if(pdfUrl){
                            <div class="d-flex" data-aos="fade-up" data-aos-delay="200">
                                <button (click)="downloadPdf()" class="btn-get-started">Download your PDF invoice</button>
                            </div>
                        } @else {
                            <div class="d-flex" data-aos="fade-up" data-aos-delay="200">
                                <a class="btn-get-started" [routerLink]="['/invoice']">Generate Free Invoice</a>
                            </div>
                        }
                    </div>
                </div>
            </div>

            @if(pdfUrl){
                <div class="col-md-10 mx-auto">
                    <div class="card">
                        <div class="card-body">                                                    
                            <div class="pdf-container">
                                <iframe [src]="pdfUrl" width="100%" height="100%" frameborder="0">
                                </iframe>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</section>